var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[(_vm.imgUrl)?_c('AulaImg',{staticClass:"profile-image",attrs:{"img-url":_vm.imgUrl}}):_c('div',{staticClass:"profile-initials"},[_vm._v("\n    "+_vm._s(_vm.initials)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }